import { HuaweiBridgeClient } from './huawei-bridge-client';
/**
 * DeviceHuawei implements the same DevicePlugin interface as
 * @capacitor/device, routing calls through the Huawei JS Bridge.
 *
 * All four methods (getId, getInfo, getBatteryInfo, getLanguageCode)
 * use the standard request-response bridge — no push callbacks needed.
 */
export class DeviceHuawei {
    constructor() {
        this.bridge = HuaweiBridgeClient.getInstance();
    }
    async getId() {
        return this.bridge.call('getId');
    }
    async getInfo() {
        return this.bridge.call('getInfo');
    }
    async getBatteryInfo() {
        return this.bridge.call('getBatteryInfo');
    }
    async getLanguageCode() {
        return this.bridge.call('getLanguageCode');
    }
}
//# sourceMappingURL=device.js.map